import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PayrollDefinitionService } from 'app/core/services/payroll-definition.service';
import { RefreshPeriodService } from 'app/core/services/refresh-period.service';
import { EmployeeRelation } from 'app/shared/models/employee-relation';
import { PayrollDepartment } from 'app/shared/models/payroll-department';

@Component({
  selector: 'dialog-add-concepts',
  templateUrl: './dialog-add-concepts.component.html',
  styleUrls: ['./dialog-add-concepts.component.scss']
})
export class DialogAddConceptsComponent implements OnInit {

  isLoading: boolean = false;
  conceptForm: FormGroup;
  concepts: any = [];
  matrix: any = [];

  constructor(public dialogRef: MatDialogRef<DialogAddConceptsComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder, private payrollDefinitionService: PayrollDefinitionService, private refreshPeriodService: RefreshPeriodService) {
    this.conceptForm = this.fb.group({
      id: [0],
      definitionId: [0],
      payConcept: [null, Validators.required],
      computePagIbig: [true, Validators.required],
      computePhilhealth: [true, Validators.required],
      computeSSS: [true, Validators.required],
      computeLate: [false, Validators.required],
      matrixPagIbig: [null, Validators.required],
      matrixPhilhealth: [null, Validators.required],
      matrixSSS: [null, Validators.required],
    });

    this.conceptForm.get('computePagIbig')?.valueChanges.subscribe((value: boolean) => {
      if (value) {
        this.conceptForm.get('matrixPagIbig')?.setValidators(Validators.required);
      } else {
        this.conceptForm.get('matrixPagIbig')?.clearValidators();
        this.conceptForm.get('matrixPagIbig')?.setValue(0);
      }
      this.conceptForm.get('matrixPagIbig')?.updateValueAndValidity();
    });

    this.conceptForm.get('computePhilhealth')?.valueChanges.subscribe((value: boolean) => {
      if (value) {
        this.conceptForm.get('matrixPhilhealth')?.setValidators(Validators.required);
      } else {
        this.conceptForm.get('matrixPhilhealth')?.clearValidators();
        this.conceptForm.get('matrixPhilhealth')?.setValue(0);
      }
      this.conceptForm.get('matrixPhilhealth')?.updateValueAndValidity();
    });

    this.conceptForm.get('computeSSS')?.valueChanges.subscribe((value: boolean) => {
      if (value) {
        this.conceptForm.get('matrixSSS')?.setValidators(Validators.required);
      } else {
        this.conceptForm.get('matrixSSS')?.clearValidators();
        this.conceptForm.get('matrixSSS')?.setValue(0);
      }
      this.conceptForm.get('matrixSSS')?.updateValueAndValidity();
    });
  }

  ngOnInit(): void {
    this.getPayrollConcept();
    this.getMatrix();

    if (this.data?.selectedConcept?.HR_PayrollConcept > 0) {
      const selectedConcept = this.data.selectedConcept;
      this.conceptForm.patchValue({
        id: selectedConcept.HR_PayrollConcept || 0,
        definitionId: selectedConcept.HR_Payroll_ID,
        payConcept: selectedConcept.conceptId || 0,
        computePagIbig: selectedConcept.RAMP_isComputePagibig || false,
        computePhilhealth: selectedConcept.RAMP_isComputePhilhealth || false,
        computeSSS: selectedConcept.RAMP_isComputeSSS || false,
        computeLate: selectedConcept.RAMP_isComputed || false,
        matrixPagIbig: selectedConcept.RAMP_PagIbig_Matrix_ID || 0,
        matrixPhilhealth: selectedConcept.RAMP_Philhealth_Matrix_ID || 0,
        matrixSSS: selectedConcept.RAMP_SSS_Matrix_ID || 0,
      });
    }

    if (this.data?.definitionId > 0) {
      console.log('Patching definitonId:', this.data.definitionId);
      this.conceptForm.patchValue({ definitionId: this.data.definitionId });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getPayrollConcept() {
    this.payrollDefinitionService.getPayrollConcept().subscribe({
      next: res => {
        this.concepts = res;
      },
      error: err => {
        console.log(err);
      }
    })
  }

  getMatrix() {
    this.payrollDefinitionService.getMatrix().subscribe({
      next: res => {
        console.log(res);
        this.matrix = res;
      },
      error: err => {
        console.log(err);
      }
    })
  }

  save() {
    this.isLoading = true;
    if (this.conceptForm.invalid) {
      Object.keys(this.conceptForm.controls).forEach((controlName) => {
        this.conceptForm.get(controlName)?.markAsTouched();
        this.isLoading = false;
      });
      return;
    }
    if (this.conceptForm.valid) {
      this.payrollDefinitionService.createUpdateConcept(this.conceptForm.value).subscribe({
        next: res => {
          this.refreshPeriodService.emitRefresh2(this.conceptForm.value.id);
          Promise.resolve().then(() => {
            this.isLoading = false;
            this.dialogRef.close();
          });
      },
        error: err => {
          console.log(err);
          this.isLoading = false;
        }
      })
  }
}
}
